module.exports = __webpack_public_path__ + "media/goal_sound.080de6c0.mp3";